export default {
      id: "cookie-1st-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#cookie-1st",
      toString: function () {
        return this.url;
      }
    }